export default __webpack_public_path__ + "static/media/586.577c0702.png";